import ChangeSendCosts from '@solundo/account/js/orders/ChangeSendCosts.js';
import SendToSunrooms from '@solundo/account/js/orders/SendToSunrooms.js';

class Order {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-account-orders="scope"]',
			toggle: '[data-account-orders="toggle"]',
			details: '[data-account-orders="details"]',
			sendCostsForm: '[data-account-orders="send_costs_form"]',
			price: '[data-account-orders="price"]',
			sendToSunrooms: '[data-account-orders="send_to_sunrooms"]',
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.addEventListeners();
	}

	addEventListeners() {
		new ChangeSendCosts(this.$scope, this.config);
		new SendToSunrooms(this.$scope, this.config);
		this.$scope.on('click', this.config.toggle, this.toggleDetails.bind(this));
	}

	toggleDetails(event) {
		let $button = $(event.currentTarget);
		let $scope = $button.closest(this.config.scope);
		let orderId = $button.data('order');
		let $target = $scope.find(`${this.config.details}[data-order="${orderId}"]`);

		if($button.data('open') == 'true') {
			$target.slideUp();
			$button.removeClass('open');
			$button.data('open', 'false');
		} else {
			$target.slideDown();
			$button.addClass('open');
			$button.data('open', 'true');
		}
	}
}

export default new Order;